// Singleton to track if session timeout is already initialized
let SessionTimeoutInstance = class SessionTimeoutInstance {
    static instance;
    isActive = false;
    constructor(){}
    static getInstance() {
        if (!SessionTimeoutInstance.instance) {
            SessionTimeoutInstance.instance = new SessionTimeoutInstance();
        }
        return SessionTimeoutInstance.instance;
    }
    activate() {
        if (this.isActive) {
            return false;
        }
        this.isActive = true;
        return true;
    }
    deactivate() {
        this.isActive = false;
    }
    isSessionActive() {
        return this.isActive;
    }
};
export const sessionTimeoutInstance = SessionTimeoutInstance.getInstance();
